/**
 * Cookie utility for cross-subdomain navigation
 */
export class CookieUtils {
    /**
     * Sets a cookie on the base domain for cross-subdomain navigation
     * @param name Cookie name
     * @param value Cookie value
     * @param days Expiry in days
     */
    public static setCookieOnBaseDomain(name: string, value: string, days: number): void {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        
        // Extract base domain from current hostname
        const hostname = window.location.hostname;
        const baseDomain = this.getBaseDomain(hostname);
        
        // Set cookie with domain attribute to make it available across subdomains
        document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; domain=${baseDomain}; path=/`;
    }

    /**
     * Gets a cookie value by name
     * @param name Cookie name
     * @returns Cookie value or null if not found
     */
    public static getCookie(name: string): string | null {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    /**
     * Extracts base domain from hostname
     * @param hostname Current hostname
     * @returns Base domain
     */
    private static getBaseDomain(hostname: string): string {
        // Handle localhost and IP addresses
        if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+/.test(hostname)) {
            return hostname;
        }
        
        // For domains like www3.domain.com, www5.domain.com, etc.
        const parts = hostname.split('.');
        if (parts.length >= 3) {
            // Return the last two parts (domain.com)
            return parts.slice(-2).join('.');
        }
        
        // For domains like domain.com
        return hostname;
    }
}
